import React, { useState } from "react";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import "./styles.less";

export const PartnerFeature = () => {
  const { t } = useTranslation();
  const topData = [
    {
      title: t("partner.feature.item1.title"),
      text: t("partner.feature.item1.text"),
    },
    {
      title: t("partner.feature.item2.title"),
      text: t("partner.feature.item2.text"),
    },
  ];
  const bottomData = [
    {
      title: t("partner.feature.item3.title"),
      text: t("partner.feature.item3.text"),
    },
    {
      title: t("partner.feature.item4.title"),
      text: t("partner.feature.item4.text"),
    },
  ];
  return (
    <div>
      <section className="partner-feature">
        <div className="feature-card-warp">
          {topData.map((item, index) => (
            <div className="feature-card top" key={index}>
              <div className="card-title">{item.title}</div>
              <div className="card-content">{item.text}</div>
            </div>
          ))}
          <div className="feature-img">
            <img
              src="//files.authing.co/authing-website/partner-global.png"
              alt="authing"
            />
          </div>
          {bottomData.map((item, index) => (
            <div className="feature-card bottom" key={index}>
              <div className="card-title">{item.title}</div>
              <div className="card-content">{item.text}</div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};
